import type { ReactNode } from 'react';
import { Icon } from './Icon';

export const rub = (value:number, compact=false) => new Intl.NumberFormat('ru-RU',{style:'currency',currency:'RUB',maximumFractionDigits:0,notation:compact?'compact':'standard'}).format(value);
export const number = (value:number) => new Intl.NumberFormat('ru-RU').format(value);

export function PageHeader({ title, copy, children }: {title:string;copy:string;children?:ReactNode}) {
  return <div className="page-head"><div><h1>{title}</h1><p>{copy}</p></div><div className="page-actions">{children}</div></div>;
}

export function Button({ children, icon, variant='secondary', onClick }: {children:ReactNode;icon?:string;variant?:'primary'|'secondary'|'ghost';onClick?:()=>void}) {
  return <button type="button" className={`button button-${variant}`} onClick={onClick}>{icon&&<Icon name={icon}/>}<span>{children}</span></button>;
}

export function MetricCard({ label, value, trend, icon, tone='green', note }: {label:string;value:string;trend:string;icon:string;tone?:string;note:string}) {
  return <article className={`metric metric-${tone}`}><div className="metric-icon"><Icon name={icon}/></div><div className="metric-copy"><span>{label}</span><strong>{value}</strong><small><b>{trend}</b> {note}</small></div></article>;
}

export function Badge({ children, tone='green' }: {children:ReactNode;tone?:'green'|'blue'|'orange'|'red'|'gray'}) { return <span className={`badge badge-${tone}`}>{children}</span>; }

export function Search({ value, onChange, placeholder }: {value:string;onChange:(value:string)=>void;placeholder:string}) {
  return <label className="search"><Icon name="search"/><input value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}/></label>;
}

export function Panel({ title, subtitle, action, children, className='' }: {title:string;subtitle?:string;action?:ReactNode;children:ReactNode;className?:string}) {
  return <section className={`panel ${className}`}><header className="panel-head"><div><h2>{title}</h2>{subtitle&&<p>{subtitle}</p>}</div>{action}</header>{children}</section>;
}
